<main>
  <header>
    <mat-toolbar style="background-color: #ffffff;" ngClass.lt-sm="xs">
        <img src="/assets/images/logo-header-red.svg" alt="Viessmann" style="height:32px;width:auto;" />
        <div class="divider"><span class="dot"></span></div>
        <div class="headline" [innerHTML]="'app.title' | translate">ProductInformation</div>
        <app-language-changer class="languages"></app-language-changer>
    </mat-toolbar>
  </header>

  <app-maintenance-banner></app-maintenance-banner>
  <div class="container-content">
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner diameter="56"></mat-spinner>
    </div>
    <router-outlet></router-outlet>
  </div>

  <footer>
    <dsw-footer *ngIf="locale" [locale]="locale" [showAccessibilityLink]=false></dsw-footer>
  </footer>
</main>





